import "./App.css";
import { Route, HashRouter as Router } from "react-router-dom";
import React, { useState } from "react";
import CustomRoutes from "@/Routes/CustomRoutes";
import { publicRoutes } from "@/Routes/publicRoutes";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "@/Shared/ScrollToTop/index";
import { Routers } from "./Routes/index";
import DashboardLayout from "./Layout/layout";
import NetworkErrorModal from "./Components/NetworkLostHandler";
import { ConfigProvider } from "antd";
function App() {
  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Baloo2",
            colorPrimary: "#8086AC",
            colorLinkActive: "#8086AC",
            colorLinkHover: "#8086AC",
            colorLink: "#8086AC",
          },
        }}
      >
        <div>
          <ScrollToTop />
          <CustomRoutes>
            {Routers.map((item, index1) => (
              <Route
                key={index1}
                path={item.path}
                element={
                  item.name === "Auth" || item.name === "notFound" ? null : (
                    <DashboardLayout />
                  )
                }
              >
                <Route index element={item.first} />
                {item.router.map(({ path, Component }, index) => {
                  return (
                    <Route
                      key={index1 + index}
                      path={path}
                      element={<Component />}
                    />
                  );
                })}
              </Route>
            ))}
          </CustomRoutes>
          <NetworkErrorModal />
          <Toaster position="top-right" reverseOrder={false} />
        </div>
      </ConfigProvider>
    </>
  );
}

export default App;
